import { setIsAdmin } from '@ports/common/sessionStateSlice';
import { clearCachedAPIs } from '../clearRedux';
import { getCognitoToken } from '../token';

export const afterLogin = async (response: any, dispatch: any) => {
  const decodedToken: any = await getCognitoToken();
  const isAdmin = decodedToken?.roleName === 'admin';
  dispatch(setIsAdmin(isAdmin));
  clearCachedAPIs(dispatch);
};
